import styled from "styled-components"

export const AdvantagesInfoContainer = styled.div`
  background: #f1f6ff;
  border: 4px solid #4387ff;
  border-radius: 25px;
  padding: 58px 45px 20px;
  margin-bottom: 100px;
  @media (max-width: 767px) {
    padding: 25px 20px 20px;
    width: 100%;
    margin-bottom: 90px;
  }
`

export const Title = styled.h2`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  color: #003591;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    font-size: 28px;
    line-height: 36px;
    max-width: 274px;
  }
`

export const SubTitle = styled.div`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #555555;
  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 28px;
    max-width: 274px;
  }
`
export const AdvantageInfoCover = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  margin-top: 30px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`
export const AdvantageBox = styled.div`
  display: flex;
  align-items: flex-start;
  width: calc(100% / 3);
  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 50px;
    &:nth-child(3) {
      margin-bottom: 0;
    }
  }
`
export const ImgCover = styled.span`
  margin-right: 15px;
  margin-top: 5px;
  @media (max-width: 767px) {
    padding-top: 5px;
  }
`
export const InfoTitle = styled.h3`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: #000308;
`
export const InfoDescription = styled.p`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: #555555;
`
export const DescCover = styled.div`
  width: 85%;
`
